import { render } from "./nodata.vue?vue&type=template&id=56e602de&scoped=true&ts=true"
import script from "./nodata.vue?vue&type=script&lang=ts"
export * from "./nodata.vue?vue&type=script&lang=ts"

import "./nodata.vue?vue&type=style&index=0&id=56e602de&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e602de"]])

export default __exports__